<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Promena datuma isporuke</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="form-label">Novi datum isporuke</label>
            <app-calendar [isNgModel]="true"
                          [(ngModel)]="deliveryDeadline"
                          [ngModelOptions]="{standalone:true}"
                          (ngModelChange)="onSelectDate($event)"></app-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="editDeliveryDeadline()">Potvrdi</button>
    </div>
  </div>
</div>
